import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { SectionWrapper } from '../Sections'
import { ITestimonial } from './types'
import { prepareData } from 'utils/googleData'

function Quote({ children, direction, className = '' }: { children: React.ReactNode[]; className?: string }) {
    return (
        <div
            dir={direction}
            className={`-mx-5 grid gap-y-8 bg-gray-accent-light py-10 px-5 md:-mx-12 md:grid-cols-2 md:gap-y-0 md:gap-x-8 md:px-16 lg:gap-x-12 xl:gap-x-16 ${className}`}
        >
            <div>{children[0]}</div>
            <div className="-mt-16">{children[1]}</div>
        </div>
    )
}

export function Testimonial(props: ITestimonial) {
    const { enable, title, quote, authors, svgImage, gatsbyImage, direction, imageStyles } = prepareData({
        props,
    })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }

    return (
        <SectionWrapper direction={direction} className="relative mt-0 !pt-0">
            <Quote direction={direction} className="items-end">
                {Array.isArray(authors) &&
                    authors.map((author, index) => {
                        return (
                            <div key={index}>
                                {author?.gatsbyImage2Src && (
                                    <img className="max-h-[45px] text-black" src={author.gatsbyImage2Src} />
                                )}
                                {quote && (
                                    <p className="my-6 text-[17px]" dangerouslySetInnerHTML={{ __html: quote }} />
                                )}

                                <div className="flex items-center space-x-4">
                                    {author?.gatsbyImageSrc && (
                                        <img className="max-w-[50px] rounded-full" src={author.gatsbyImageSrc} />
                                    )}
                                    <div>
                                        {author?.name && <p className="m-0 font-bold">{author?.name}</p>}
                                        {author?.role && author?.companyName && (
                                            <p className="m-0 opacity-70">
                                                {author?.role}, {author?.companyName}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                <div>
                    {gatsbyImage && <GatsbyImage alt="" image={gatsbyImage} />}
                    {svgImage && !gatsbyImage && <img alt="" src={svgImage} />}
                </div>
            </Quote>
        </SectionWrapper>
    )
}
export default Testimonial
